module.exports = __webpack_public_path__ + "img/level_4e.77de6af2.png";